import React, { useState } from "react";
import queryString from "query-string";
import { history } from "../../_redux/_store/history";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { createNewRecommendation } from "../../_redux/_actions/recommendationListActions";
import { getAllRecommendationList } from "../../_redux/_actions/recommendationListActions";
import Grid from "@material-ui/core/Grid";
import MuiDialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import CancelIcon from "@material-ui/icons/Cancel";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { useDispatch } from "react-redux";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ErrorHandler from '../updateHandlers/ErrorHandler'
import IconButton from "@material-ui/core/IconButton";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "90%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  Button: {
    width: "120px",
    marginRight: "20px",
    "&:hover": {
      background: "#52A1C2",
    },
  },
  helpIcon: {
    marginBottom: "10px",
    marginLeft: "0.5px",
    width: "20px",
  },
  CancelIcon: {
    "&:hover": {
      background: null,
    },
  },
  closeBarContainer:{
    width: '5%',
    height:'100vh',
    backgroundColor:"#262523",
    justifyContent: 'center',
    display: 'flex'
  },
}));

const Dialog = withStyles(() => ({
  paper: {
    backgroundColor: "#F6F6F6",
    margin:'unset !important'
  },
  paperWidthSm: {
    maxHeight: 'none',
    height: '100%',
    width:'80%',
    maxWidth: '80%'
  }
}))(MuiDialog);

export default function CreateRecommendation({
  open,
  onClose
}) {
  const classes = useStyles();
  const [descriptionText, setDescriptionText] = useState("");
  const [effortText, setEffortText] = useState("");
  const [roleText, setRoleText] = useState("");
  const [effortValue, setEffortValue] = useState("");
  const [roleValue, setRoleValue] = useState("");
  const [errorEffortValue, setErrorEffortValue] = useState(false);
  const [errorRoleValue, setErrorRoleValue] = useState(false);
  const [openSuccessMsg, setOpenSuccessMsg] = useState(false);
  const [failure, setFailure] = useState(false)
  const queryValues = queryString.parse(history.location.search)
  const {machine_type, hmi_type} = queryValues
  const dispatch = useDispatch();

  const handleDescriptionChange = (value) => {
    setDescriptionText(value);
  };

  const handleEffortChange = (event) => {
    setEffortText(event.target.value);
    if (event.target.value === 1) {
      setEffortValue("XS");
      setErrorEffortValue(false);
    } else if (event.target.value === 2) {
      setEffortValue("S");
      setErrorEffortValue(false);
    } else if (event.target.value === 3) {
      setEffortValue("M");
      setErrorEffortValue(false);
    } else if (event.target.value === 4) {
      setEffortValue("L");
      setErrorEffortValue(false);
    } else {
      setErrorEffortValue(true);
    }
    if (!event.target.value) {
      setErrorEffortValue(true);
    }
  };
  const handleRoleChange = (event) => {
    setRoleText(event.target.value);
    if (event.target.value === 1) {
      setRoleValue("O");
      setErrorRoleValue(false);
    } else if (event.target.value === 2) {
      setRoleValue("M");
      setErrorRoleValue(false);
    } else if (event.target.value == 3) {
      setRoleValue("E");
      setErrorRoleValue(false);
    } else if (event.target.value === 4) {
      setRoleValue("M+E");
      setErrorRoleValue(false);
    } else {
      setErrorRoleValue(true);
    }
    if (!event.target.value) {
      setErrorRoleValue(true);
    }
  };

  const updateNewRecommendation = () => {
    if (
      errorRoleValue !== true &&
      errorEffortValue !== true &&
      effortValue !== "" &&
      roleValue !== ""
    ) {
      const body = {
        description: descriptionText,
        effort: effortValue,
        department: roleValue,
      };
      dispatch(createNewRecommendation(body,machine_type, hmi_type, handleCreateRecommendation));
    } else {
      if (effortValue === "") {
        setErrorEffortValue(true);
      }
      if (roleValue === "") {
        setErrorRoleValue(true);
      }
    }
  };

  const handleCreateRecommendation = (val) => {
    if (val) {
      dispatch(getAllRecommendationList(machine_type, hmi_type));
      setOpenSuccessMsg(val)
    }else {setFailure(true)}
  };

  const closeDialog = () =>{
    setOpenSuccessMsg(false);
    onClose();
  }

  return (
    <Grid>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={"md"}
        PaperProps={{
          style: {overflow:"hidden", position:'fixed', right:'0', height:'100vh', maxHeight:'none', maxWidth:"unset", width:"76%"},
        }}
      >
        <Grid container direction="row">
          <Grid item className={classes.closeBarContainer}>
            <div>
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={onClose}
                >
                <CancelRoundedIcon style={{color:"#ffffff"}} />
              </IconButton>
            </div>
          </Grid>
          <Grid item style={{width:'95%', height:"100vh"}}>
              <DialogContent style={{ overflow: "hidden" }}>
              <Grid item container direction="column" justifyContent="center">
                <Grid
                  item
                  style={{ marginBottom: "2em", marginTop: "1em" }}
                >
                  <Typography style={{ color: "#52A1C2", fontWeight: 700 }}>
                    Create Recommendation
                  </Typography>
                </Grid>
                <Grid item style={{ marginBottom: "2em" }}>
                  <TextField
                    fullWidth
                    label="Description of Recommendation"
                    multiline
                    rows={6}
                    onChange={(e) => handleDescriptionChange(e.target.value)}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  container
                  direction="row"
                  style={{ marginBottom: "20px", marginTop: "30px" }}
                >
                  <Grid item md={6}>
                    <FormControl
                      required
                      className={classes.formControl}
                      error={errorEffortValue === true ? true : false}
                    >
                      <InputLabel
                        shrink
                        id="demo-simple-select-placeholder-label-label"
                      >
                        Effort
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-placeholder-label-label"
                        id="handleEffortChange"
                        value={effortText}
                        onChange={handleEffortChange}
                        displayEmpty
                        className={classes.selectEmpty}
                        data-testid="effortChange"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value={1}>XS</MenuItem>
                        <MenuItem value={2}>S</MenuItem>
                        <MenuItem value={3}>M</MenuItem>
                        <MenuItem value={4}>L</MenuItem>
                      </Select>
                      <FormHelperText>
                        {" "}
                        XS: visu only / machine keeps running; S: ~5 min down e.g.
                        during buffer stop; M: up to 1h down; L: {">"} 1h down
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item md={6}>
                    <FormControl
                      required
                      className={classes.formControl}
                      error={errorRoleValue === true ? true : false}
                    >
                      <InputLabel
                        shrink
                        id="demo-simple-select-placeholder-label-label"
                      >
                        Role
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-placeholder-label-label"
                        id="handleRoleChange"
                        value={roleText}
                        onChange={handleRoleChange}
                        displayEmpty
                        className={classes.selectEmpty}
                        data-testid="roleChange"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value={1}>O</MenuItem>
                        <MenuItem value={2}>M</MenuItem>
                        <MenuItem value={3}>E</MenuItem>
                        <MenuItem value={4}>M+E</MenuItem>
                      </Select>
                      <FormHelperText>
                        {" "}
                        O: operator; M: mechanic; E: electrician; M+E: mechanic +
                        electrician
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  style={{ marginBottom: "20px", marginTop: "30px" }}
                >
                  <Grid item>
                    <Button
                      variant="outlined"
                      className={classes.Button}
                      onClick={() => updateNewRecommendation()}
                    >
                      Done
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      className={classes.Button}
                      onClick={onClose}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
          </Grid>
        </Grid>
      </Dialog>
      { openSuccessMsg && <CreateRecommendationSuccess close={closeDialog}/>}

      {/*create recommendation error */}
      {failure && (
            <ErrorHandler message={"Failed to create recommendation"} />
      )}

    </Grid>
  );
}

export const CreateRecommendationSuccess = ({close}) => {
  const classes = useStyles();
  return (
    <Grid>
      <Dialog
        //open={open}
        maxWidth={"md"}
        PaperProps={{ style: { width: "40em", height: "20em" } }}
      >
        <DialogContent style={{ padding: "30px" }}>
          <Grid
            item
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item>
              <CheckCircleOutlineIcon
                style={{ width: "3em", height: "3em", color: "#52A1C2" }}
              />
            </Grid>
            <Grid item style={{ marginTop: "20px", marginBottom: "20px" }}>
              New Recommendation has been created successfully
            </Grid>
            <Grid item>
              <Button
                onClick={close}
                className={classes.Button}
                variant="outlined"
              >
                <Typography>OK</Typography>
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Grid>
  );
};
